import React, { useState } from "react";

const CommentForm = ({ taskId, parentCommentId = null, onSuccess }) => {
  const [commentText, setCommentText] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const authToken = localStorage.getItem("auth_token");

  const handleFileChange = (e) => {
    setAttachments(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!commentText.trim() && attachments.length === 0) {
      alert("Please enter a comment or select at least one attachment.");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("comment", commentText);
    if (parentCommentId) {
      formData.append("parent_comment_id", parentCommentId);
    }
    attachments.forEach((file) => formData.append("attachments[]", file));

    try {
      const res = await fetch(
        `https://loopsneller.com/api/tasks/${taskId}/comments`,
        {
          method: "POST",
          body: formData,
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (!res.ok) {
        const contentType = res.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          const errorData = await res.json();
          throw new Error(errorData.error || "Failed to post comment");
        } else {
          const text = await res.text(); // HTML fallback
          throw new Error("Unexpected server response:\n" + text);
        }
      }

      setCommentText("");
      setAttachments([]);
      onSuccess(); // Refresh comments
    } catch (err) {
      console.error("Error submitting comment:", err);
      alert(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-2">
      <div className="mb-2">
        <textarea
          className="form-control"
          placeholder={
            parentCommentId ? "Write a reply..." : "Write a comment..."
          }
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          rows={2}
          required={attachments.length === 0}
        />
      </div>

      <div className="mb-2">
        <input
          type="file"
          className="form-control"
          multiple
          onChange={handleFileChange}
        />
      </div>

      <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary btn-sm"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Posting..." : parentCommentId ? "Reply" : "Comment"}
        </button>
      </div>
    </form>
  );
};

export default CommentForm;
